import {API_LOGGING, AUTH_LOGGING, QUEUE_LOGGING, REDUX_LOGGING, RESTORE_LOGGING, WSS_LOGGING} from "../../lib/localStorage";
import {LocalStorageType as StorageType, useLocalStorage} from '../../hooks/useLocalStorage';
import i18n from "../../i18n/i18n";
import React from "react";
import Checkbox from "../../ui/Checkbox";

function AdvancedDiagnostics() {
    const [useApiLogging, setUseApiLogging] = useLocalStorage<StorageType.boolean, boolean>(API_LOGGING, StorageType.boolean, false);
    const [useAuthLogging, setUseAuthLogging] = useLocalStorage<StorageType.boolean, boolean>(AUTH_LOGGING, StorageType.boolean, false);
    const [useQueueLogging, setUseQueueLogging] = useLocalStorage<StorageType.boolean, boolean>(QUEUE_LOGGING, StorageType.boolean, false);
    const [useReduxLogging, setUseReduxLogging] = useLocalStorage<StorageType.boolean, boolean>(REDUX_LOGGING, StorageType.boolean, false);
    const [useRestoreLogging, setUseRestoreLogging] = useLocalStorage<StorageType.boolean, boolean>(RESTORE_LOGGING, StorageType.boolean, false);
    const [useWssLogging, setUseWssLogging] = useLocalStorage<StorageType.boolean, boolean>(WSS_LOGGING, StorageType.boolean, false);

    return <section id='advanced_diagnostics'>
        {/* Warning: this will slow down the application, sometimes significantly */}
        <article>
            <div style={{color: 'var(--sl-color-warning-800)'}}>Do not enable unless requested by Outlaw Practice Support.</div>
            <aside>
                <p>Turning on logging can impact application performance, sometimes significantly.
                    Only turn on long enough for Support to diagnose the issue.
                </p>
                <p>Changes here require a reloading of the application (browser refresh).</p>
            </aside>
        </article>

        <article style={{marginTop: '1.5em'}}>
            <Checkbox checked={useAuthLogging}
                      onClick={() => setUseAuthLogging(!useAuthLogging)}
                      label={i18n.l('config', 'authLogging')}
            />
            <aside>{i18n.d('config', 'authLogging')}</aside>
        </article>

        <article style={{marginTop: '1.5em'}}>
            <Checkbox checked={useWssLogging}
                      onClick={() => setUseWssLogging(!useWssLogging)}
                      label={i18n.l('config', 'wssLogging')}
            />
            <aside>{i18n.d('config', 'wssLogging')}</aside>
        </article>

        <article style={{marginTop: '1.5em'}}>
            <Checkbox checked={useApiLogging}
                      onClick={() => setUseApiLogging(!useApiLogging)}
                      label={i18n.l('config', 'apiLogging')}
            />
            <aside>{i18n.d('config', 'apiLogging')}</aside>
        </article>

        <article style={{marginTop: '1.5em'}}>
            <Checkbox checked={useReduxLogging}
                      onClick={() => setUseReduxLogging(!useReduxLogging)}
                      label={i18n.l('config', 'reduxLogging')}
            />
            <aside>{i18n.d('config', 'reduxLogging')}</aside>
        </article>

        <article style={{marginTop: '1.5em'}}>
            <Checkbox checked={useQueueLogging}
                      onClick={() => setUseQueueLogging(!useQueueLogging)}
                      label={i18n.l('config', 'queueLogging')}
            />
            <aside>{i18n.d('config', 'queueLogging')}</aside>
        </article>

        <article style={{marginTop: '1.5em'}}>
            <Checkbox checked={useRestoreLogging}
                      onClick={() => setUseRestoreLogging(!useRestoreLogging)}
                      label={i18n.l('config', 'restoreLogging')}
            />
            <aside>{i18n.d('config', 'restoreLogging')}</aside>
        </article>
    </section>;
}

export default AdvancedDiagnostics;